import AddressAppResource from './AddressAppResource';
import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import EmailAppResource from './EmailAppResource';
import OrganizationAppResource from './OrganizationAppResource';
import PhoneAppResource from './PhoneAppResource';
import PropertyAppResource from './PropertyAppResource';
import UserAppResource from './UserAppResource';
import WildAppResource from './WildAppResource';
import WorkspaceAppResource from './WorkspaceAppResource';
import ChannelAppResource from "./ChannelAppResource";

class PropertyInstanceAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Property-Instance';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'properties/instances';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'created_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'name',
            'yearBuilt',
            'noOfUnits',
            'price',
            'type',
            'subtype',
            'status',
            'bedrooms',
            'bathrooms',
            'size',
            'sizeUnits',
            'lotSize',
            'lotSizeUnits',
            'details',
            'propertyUuid',
            'ownerUserUuid',
            'organizationUuid',
            'workspaceUuid',
            'property',
            'organization',
            'workspace',
            'channels',
            'files',
            'emails',
            'phones',
            'addresses',
            'isFavorite',
            'isCore',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            property: PropertyAppResource,
            ownerUser: UserAppResource,
            organization: OrganizationAppResource,
            workspace: WorkspaceAppResource,
            files: WildAppResource,
            emails: EmailAppResource,
            phones: PhoneAppResource,
            addresses: AddressAppResource,
            channels: ChannelAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            property: 'property_uuid',
            ownerUser: 'owner_user_uuid',
            organization: 'organization_uuid',
            workspace: 'workspace_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            name: {
                type: 'string',
            },
            yearBuilt: {
                numericality: true,
            },
            noOfUnits: {
                numericality: true,
            },
            price: {
                numericality: true,
            },
            type: {
                type: 'string',
            },
            subtype: {
                type: 'string',
            },
            status: {
                type: 'string',
            },
            bedrooms: {
                numericality: true,
            },
            bathrooms: {
                numericality: true,
            },
            size: {
                numericality: true,
            },
            sizeUnits: {
                type: 'string',
            },
            lotSize: {
                numericality: true,
            },
            lotSizeUnits: {
                type: 'string',
            },
            ownerUserUuid: {
                type: 'string',
                presence: true,
            },
            organizationUuid: {
                type: 'string',
                presence: true,
            },
            workspaceUuid: {
                type: 'string',
                presence: true,
            },
            emails: {
                type: 'array'
            },
            phone: {
                type: 'array'
            },
            addresses: {
                type: 'array'
            },
            isFavorite: {
                type: 'boolean',
            },
            isCore: {
                type: 'boolean',
            },
        };
    }

}

export default PropertyInstanceAppResource;
